exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info_text[data-v-04fb33d4]{text-align:left;padding-left:0;font-size:15px;font-weight:700}.info_scan[data-v-04fb33d4]{text-align:right;font-size:8px}.info_tip[data-v-04fb33d4]{text-align:center;color:#1989fa;background-color:#ecf9ff}.qr_view[data-v-04fb33d4]{background-color:#fff;-webkit-box-shadow:1px 1px 5px #999;box-shadow:1px 1px 5px #999;border-radius:5px}", ""]);

// exports
